export const BASE_URL = 'https://api.triyit.dev';
